import { render, staticRenderFns } from "./rg-tabs.vue?vue&type=template&id=3faeb8f6&"
import script from "./rg-tabs.vue?vue&type=script&lang=js&"
export * from "./rg-tabs.vue?vue&type=script&lang=js&"
import style0 from "./rg-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports